module.exports = __webpack_public_path__ + "img/gsqj_20.793a8c27.png";